import PropTypes from 'prop-types';
import React, { lazy } from 'react';
import { useTranslation } from 'react-i18next';

import { mediaUrls } from 'globalconfig/constants/mediaUrls';
import Table from '../Dashboard/DriverStatus';
import Styled from './DriverStatusListStyle';
import { checkServiceProvider } from './serviceProviderConfig';

const layout = window?.$environment?.CURRENT_LAYOUT;
const GoogleMap = lazy(() => import(`globalcomponents/GoogleMap/${layout}`));
const Search = lazy(() =>
  import(`globalcomponents/UI/SimpleSearch/${layout}`)
);
const Icon = lazy(() => import(`globalcomponents/UI/Icon/${layout}`));

const Component = ({ list, changeRequest }) => {
  const SERVICE_PROVIDER = window?.$environment?.SERVICE_PROVIDER;
  const i18n = useTranslation();

  const selectChange = (e) => {
    changeRequest({ search: e });
  };
  return (
    <>
      <Styled.Wrapper>
        <Styled.SearchWrapper>
          <Search
            onChange={(e) => selectChange(e)}
            default={list}
            fromData={false}
            placeHolder={i18n.t('common.driverName')}
            query={'fullName'}
            width="35%"
            id="driver_status"
          />
        </Styled.SearchWrapper>
        <Styled.MapWrapper>
          {checkServiceProvider(
            'driverStatusList_mapWrapper',
            SERVICE_PROVIDER
          ) && <GoogleMap type={'driverStatusMap'} height={'400px'} />}
        </Styled.MapWrapper>
        <Styled.TableWrapper>
          <Icon
            src={mediaUrls?.addVehicle}
            onClick={() => changeRequest()}
          />
          <span className="tooltiptext">{i18n.t('common.refresh')}</span>
          <Table driverStatus={list} />
        </Styled.TableWrapper>
      </Styled.Wrapper>
    </>
  );
};

export default Component;

Component.propTypes = {
  list: PropTypes.object.isRequired,
  filterSuccess: PropTypes.func.isRequired
};
